import { Award, BookOpen, Briefcase, GraduationCap } from "lucide-react";
import { Reveal } from "./Reveal";

const TIMELINE = [
  { icon: GraduationCap, year: "2004", text: "Contadora Pública, especialización en Finanzas y Revisoría Fiscal" },
  { icon: Briefcase, year: "2006–2014", text: "Senior Auditor en KPMG: auditorías a grupos empresariales regionales" },
  { icon: Award, year: "2015", text: "Fundación del instituto: +4.500 egresados en Latinoamérica" },
  { icon: BookOpen, year: "2023", text: "Autora de 'NIIF sin dolor' y docente de posgrado universitario" },
];

export const Instructor = () => (
  <section id="instructora" data-testid="instructor-section" className="py-24 sm:py-32 bg-secondary/30 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="absolute -inset-4 rounded-3xl border border-emerald-500/30 rotate-2" />
          <div className="relative rounded-3xl overflow-hidden border border-border shadow-2xl aspect-[4/5]">
            <img
              src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=1200"
              alt="CP Elena Valenzuela, directora académica"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5">
              <p className="font-display font-bold text-xl text-white">CP Elena Valenzuela</p>
              <p className="text-xs text-white/80 font-mono uppercase tracking-widest mt-1">Directora académica</p>
            </div>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7">
        <Reveal>
          <p className="text-xs uppercase font-mono tracking-[0.28em] text-emerald-600 dark:text-emerald-400 font-semibold mb-4">Tu mentora</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            20 años auditando. <span className="font-serif italic text-emerald-500">Una década enseñando.</span>
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed mt-5 max-w-xl">
            Elena lideró auditorías en KPMG antes de fundar este instituto con una convicción: la contabilidad se aprende haciendo. Hoy combina la consultoría tributaria activa con la enseñanza, para que cada clase llegue fresca de la vida real.
          </p>
        </Reveal>

        <div className="mt-10 space-y-0">
          {TIMELINE.map((t, i) => (
            <Reveal key={t.year} delay={i * 0.08}>
              <div data-testid={`timeline-item-${i}`} className="flex gap-5 py-5 border-b border-border/70 group">
                <span className="w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/25 text-emerald-500 flex items-center justify-center shrink-0 group-hover:bg-emerald-500 group-hover:text-white transition-colors">
                  <t.icon className="w-5 h-5" />
                </span>
                <div>
                  <p className="font-mono text-xs text-emerald-600 dark:text-emerald-400 tracking-widest">{t.year}</p>
                  <p className="text-sm mt-1 leading-relaxed">{t.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <a
            data-testid="instructor-advisory-btn"
            href="#contacto"
            onClick={(e) => { e.preventDefault(); document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-flex mt-8 rounded-full border border-emerald-500/50 text-emerald-600 dark:text-emerald-400 font-semibold px-7 py-3.5 text-sm hover:bg-emerald-500 hover:text-white transition-all"
          >
            Solicitar asesoría directa
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
